import { render, staticRenderFns } from "./Остатки по дням.vue?vue&type=template&id=8d513a5a&scoped=true"
import script from "./Остатки по дням.vue?vue&type=script&lang=js"
export * from "./Остатки по дням.vue?vue&type=script&lang=js"
import style0 from "./Остатки по дням.vue?vue&type=style&index=0&id=8d513a5a&prod&scoped=true&lang=css"
import style1 from "./Остатки по дням.vue?vue&type=style&index=1&id=8d513a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d513a5a",
  null
  
)

export default component.exports